module.exports = __webpack_public_path__ + "static/Dona-Bold-9f4f9f27f4856b4e3510f35dcd02f935.woff2";